import React from 'react';
import styled from 'styled-components';

const ContainerStyle = styled.div`
  text-align: center;
  -webkit-font-smoothing: antialiased;
  word-break: break-word;
`;

const TitleStyle = styled.div`
  font-weight: 700;
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
`;

const ProductHeader = ({ title }) => {
  return (
    <ContainerStyle>
      <TitleStyle>{title}</TitleStyle>
    </ContainerStyle>
  );
};

export default ProductHeader;
